import { render, staticRenderFns } from "./InputVer.vue?vue&type=template&id=6a4aeaa6&lang=true&"
import script from "./InputVer.vue?vue&type=script&lang=js&"
export * from "./InputVer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports